import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './VoucherWaitingListTranslate';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import useTableFilter from '../../components/TableFilter/useTableFilter';
import {
  loadAppointments,
  clearState,
  voucherWaitingListModule
} from './VoucherWaitingListDucks';
import StaticTablePaginated from '../../_ui/Table/StaticTablePaginated';
import i18n from 'i18next';
import { StyledCardsContainer } from './VoucherWaitingListStyle';
import { requestsColumns } from './TableColumns/TableColumns';

function VoucherWaitingList() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data, pageNumber, totalElements, loading } = useSelector(
    state => state[voucherWaitingListModule]
  );
  const loadData = filter => dispatch(loadAppointments(filter));

  const { toPage, filter } = useTableFilter(loadData, '', {
    pageNumber: 1,
    pageSize: 10
  });

  useEffect(() => {
    dispatch(clearState());
  }, [dispatch]);

  return (
    <div className="mb3 mt3" style={{ width: '100%' }}>
      <Typography
        children={t('voucher_waitingList_subtitle')}
        color="secondary"
        variant="h6"
        style={{ paddingLeft: '10px' }}
      />

      <StyledCardsContainer>
        <StaticTablePaginated
          TheadComponent={_ => null}
          pageNumber={pageNumber}
          loading={loading}
          data={data}
          totalElements={totalElements}
          columns={requestsColumns({
            t,
            filter,
            pageNumber,
            lang: i18n.language
          })}
          filterable={false}
          pageSize={10}
          pagePagination={page => {
            if (page !== pageNumber) {
              toPage(page);
            }
          }}
        />
      </StyledCardsContainer>
    </div>
  );
}

export default VoucherWaitingList;
